// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const SET_VIEW_TYPE = 'view-type/SET_VIEW_TYPE';
